import Vue from "vue";
import VueI18n from "vue-i18n";


Vue.use(VueI18n);
const locales = require.context(
  "./locales",
  true,
  /[A-Za-z0-9-_,\s]+\.json$/i
);

function loadLocaleMessages() {

  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function localeNames() {
const filenames = locales.keys();
/*The forthcoming can be modified in case we want to extract more than the language.
I.e., at the moment, if we have an en-GB.json in locales, it will extract the en.
However, if there are two versions of English (e.g. en-US) we might need to extract more. */

const localeLangs =filenames.map(filename => {
  const start = filename.lastIndexOf('/') + 1; // Get the index after the last '/'
  const end = filename.lastIndexOf('-'); // Get the index before the '-'
  return filename.substring(start, end);
});

return localeLangs;

}

const dateTimeFormatDefaults = {
  'euro': {
    date: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    time: {
      hour: 'numeric', minute: 'numeric', hour12: false
    },
    datetime: {
     	year: 'numeric', month: 'short', day: 'numeric' ,
    	hour: 'numeric', minute: 'numeric', hour12: false
    },
    monthyear: {
     	year: 'numeric', month: 'short'
    }
  },
  'us': {
    date: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    time: {
      hour: 'numeric', minute: 'numeric'
    },
    datetime: {
     	year: 'numeric', month: 'short', day: 'numeric' ,
    	hour: 'numeric', minute: 'numeric', hour12: true
    },
    monthyear: {
     	year: 'numeric', month: 'short'
    }
  }
}

const dateTimeFormats = Object.fromEntries(
  localeNames().map(name => [name, dateTimeFormatDefaults.euro])
);
// Write in exceptions here
dateTimeFormats['en-US'] = dateTimeFormatDefaults.us

export default new VueI18n({
  locale: null,
  fallbackLocale: 'no-TR',
  messages: loadLocaleMessages(),
  dateTimeFormats
});
